<template>
  <v-card elevation="0">
    <v-card-text>
      <v-container grid-list-lg fill-height>
        <v-form ref="form" enctype="multipart/form-data" novalidate v-model="valid">
          <v-layout wrap>
            <v-flex xs6 sm4>
              <v-text-field
                v-model="incident.code"
                label="Código"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field
                v-model="created"
                label="Creado"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field
                v-model="modified"
                label="Modificado"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4>
              <v-select
                :items="masters.severities"
                v-model="incident.severity"
                :cache-items="true"
                :loading="loading"
                label="Criticidad"
                item-value="id"
                item-text="name"
                @change="fieldErrors.severity = []"
                :error-messages="fieldErrors.severity"
                required
              ></v-select>
            </v-flex>
            <v-flex xs6 sm4>
              <v-select
                :items="masters.statuses"
                v-model="incident.status"
                :loading="loading"
                :cache-items="true"
                label="Estado"
                item-value="id"
                item-text="name"
                @change="fieldErrors.status = []"
                :error-messages="fieldErrors.status"
                required
              ></v-select>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field
                v-model="incident.priority"
                label="Prioridad"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="incident.machine"
                :items="masters.machines"
                :loading="loading"
                :cache-items="true"
                label="Máquina"
                item-value="id"
                item-text="name"
                @change="fieldErrors.machine = []"
                :error-messages="fieldErrors.machine"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field
                label="Operador"
                type="text"
                v-model="incident.operator"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field
                label="Duración"
                suffix="minutos"
                type="number"
                v-model="incident.duration"
                @input="fieldErrors.duration = []"
                :error-messages="fieldErrors.duration"
                />
            </v-flex>
            <v-flex xs6 sm4 v-if="incident.process" @click="$router.push({name: 'process-detail', params: {'id': incident.process.id}})">
              <v-select
                :items="[incident.process]"
                v-model="incident.process"
                label="Proceso"
                item-value="id"
                item-text="code"
                append-icon="link"
                disabled
              ></v-select>
            </v-flex>
            <v-flex md6 xs12>
              <v-textarea
                v-model="incident.description"
                label="Descripción"
                :rules="descriptionRules" class="textarea" required
                @input="fieldErrors.description = []"
                :error-messages="fieldErrors.description"
                rows=9
              ></v-textarea>
            </v-flex>
            <v-flex md6 xs12>
              <div v-if="incident.attachment">
                <v-img
                  :src="incident.attachment"
                  height="80px"
                  contain
                ></v-img>
                <v-btn color="accent" :href="incident.attachment"  flat block>
                  Ver imagen a pantalla completa
                </v-btn>
              </div>
              <FilePond
                name="attachment"
                ref="pond"
                labelIdle="Subir imagen"
                labelFileLoading="Cargando"
                labelFileProcessing="Subiendo"
                labelFileProcessingComplete="Subido con éxito"
                labelFileProcessingAborted="Subida cancelada"
                labelFileProcessingError="Error subiendo fichero"
                labelTapToCancel="Tocar para cancelar"
                labelTapToRetry="Tocar para reintentar"
                labelTapToUndo="Tocar para deshacer"
                labelButtonAbortItemProcessing="Cancelar"
                labelButtonRetryItemLoad="Reintentar"
                labelButtonProcessItem="Subir"
                allowMultiple="false"
                acceptedFileTypes="image/jpeg, image/png"
                v-bind:files="myFiles"
                :server="server"
                v-on:processfile="handleFileProcessed"
                />
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn
        color="accent"
        depressed
        large
        @click="submit"
        :disabled="!valid"
        :loading="loading"
        >
          Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api/app'
import formMixin from '@/mixins/formMixin'
import mutationsMixin from '@/mixins/mutationsMixin'
import FilePond, { registerPlugin } from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
registerPlugin(FilePondPluginFileValidateType)

export default {
  name: 'incidentForm',
  components: {FilePond},
  mixins: [formMixin, mutationsMixin],
  mounted () {
    this.loading = true

    let p1 = api.getIncident(this.$route.params.id).then(response => {
      this.incident = response
      this.$store.state.pageTitle = 'Incidencias | ' + this.incident.code
    })

    let p2 = api.getSeverities().then(response => {
      this.masters.severities = response
    })

    let p3 = api.getIncidentStatuses().then(response => {
      this.masters.statuses = response
    })

    let p4 = api.getMachines().then(response => {
      this.masters.machines = response
    })

    Promise.all([p1, p2, p3, p4]).then(() => {
      this.loading = false
    })
  },
  computed: {
    created () {
      return this.$options.filters.formatDateTime(this.incident.created)
    },
    modified () {
      return this.$options.filters.formatDateTime(this.incident.modified)
    },
    submitData () {
      return {
        status: this.incident.status,
        description: this.incident.description,
        severity: this.incident.severity,
        operator: this.incident.operator,
        duration: this.incident.duration,
        machine: this.incident.machine
      }
    }
  },
  data () {
    return {
      masters: {
        severities: []
      },
      myFiles: [],
      incident: {},
      descriptionRules: [
        v => !!v || 'Descripción es obligatoria'
      ],
      server: {
        url: api.config().apiURL,
        process: {
          url: './incidents/' + this.$route.params.id + '/',
          method: 'PATCH',
          withCredentials: false,
          headers: api.config().headers,
          timeout: 7000
        }
      }
    }
  },
  methods: {
    handleFileProcessed () {
      api.getIncident(this.$route.params.id).then(response => {
        this.incident = response
      })
    },
    onSubmit () {
      return api.editIncident(this.incident.id, this.submitData)
    },
    onSuccess () {
      this.success('Incidencia actualizada con éxito')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Incident.vue